import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    requestStatus: false
  },
  getters: {
  },
  mutations: {
    changeRequestStatus(state, value) {
      state.requestStatus = value
    }
  },
  actions: {
  },
  modules: {
  }
})
